import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberVouchers } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberVouchers.Api.InitRequest
  ): Promise<HttpApiResponse<MemberVouchers.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/vouchers`, args)
};
